import React, { type FormEvent } from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { SidebarVisibility } from 'src/constants/sidebarVisibility';
import { useResources } from 'src/resources';
import { type RootState, useAppSelector } from 'src/store/reducers';
import { getAccessibilityToResponse } from 'src/util/extension';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import Sidebar from './SidebarComponent';

type Props = {
  toggleSidebarOpen: (e: Event | FormEvent<unknown> | undefined) => void;
  isSidebarOpen: boolean;
};
const RenderSidebar = ({ toggleSidebarOpen, isSidebarOpen }: Props): React.JSX.Element | null => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const sidebarData = useAppSelector((state: RootState) => state.refero.ui.sidebarData);
  const userMetadata = useAppSelector((state: RootState) => state.refero.ui.userMetadata);
  const formDefinition = useAppSelector((state: RootState) => state.refero.form.FormDefinition);
  const sidebarVisibility = useAppSelector((state: RootState) => state.refero.ui.sidebarVisibility);
  const isSavedInDokumenter = useAppSelector((state: RootState) => state.refero.ui.isSavedInDokumenter);
  const kanLagresEtterInnsending = useAppSelector((state: RootState) => state.refero.ui.kanLagresEtterInnsending);
  const printReference = useAppSelector((state: RootState) => state.refero.ui.printReference);
  const { isMicroweb, showSidebar } = useAppSelector(state => state.microweb);

  const hideSidebar =
    !resources ||
    !sidebarData ||
    !formDefinition?.Content?.title ||
    !userMetadata ||
    sidebarVisibility === SidebarVisibility.Off ||
    (isMicroweb && !showSidebar);

  const closeSidebar = (e: Event | FormEvent<unknown> | undefined): void => {
    toggleSidebarOpen(e);
  };
  if (hideSidebar) {
    return null;
  }
  return (
    <Sidebar
      isOpen={isSidebarOpen}
      toggleShowSidebar={toggleSidebarOpen}
      sidebarData={sidebarData}
      hideSidebar={closeSidebar}
      showSidebar={toggleSidebarOpen}
      resources={resources}
      formTitle={formDefinition?.Content?.title || ''}
      kanSendes={!isSavedInDokumenter}
      kanLagres={kanLagresEtterInnsending}
      harRepresentasjonsMulighet={isAuthorized() && !userMetadata.CanOnlyBePerformedBySubject}
      accessibilityToResponse={formDefinition?.Content ? getAccessibilityToResponse(formDefinition.Content) : undefined}
      printReference={isAuthorized() ? undefined : printReference}
    />
  );
};
export default RenderSidebar;
